export default {
  vi: {
    aAuthTitle: 'Đăng nhập quản trị',
    aAuthSubtitle: 'Khu vực riêng của quản trị viên, không dùng cho thành viên.',
    aAuthIdentifier: 'Tài khoản quản trị',
    aAuthPassword: 'Mật khẩu',
    aAuthSubmit: 'Đăng nhập',
    aAuthSubmitting: 'Đang đăng nhập...',
    aAuthNoPermission: 'Tài khoản này không có quyền vào trang quản trị.',
    aAuthSessionExpired: 'Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại.',
    aAuthBackToSite: 'Về trang thành viên',
    aAuthEnterAdmin: 'Vào trang quản trị',
  },
  en: {
    aAuthTitle: 'Admin sign in',
    aAuthSubtitle: 'Back-office area for administrators only.',
    aAuthIdentifier: 'Admin account',
    aAuthPassword: 'Password',
    aAuthSubmit: 'Sign in',
    aAuthSubmitting: 'Signing in...',
    aAuthNoPermission: 'This account has no back-office access.',
    aAuthSessionExpired: 'Your session has expired, please sign in again.',
    aAuthBackToSite: 'Back to member site',
    aAuthEnterAdmin: 'Admin panel',
  },
  ko: {
    aAuthTitle: '관리자 로그인',
    aAuthSubtitle: '관리자 전용 백오피스 영역입니다.',
    aAuthIdentifier: '관리자 계정',
    aAuthPassword: '비밀번호',
    aAuthSubmit: '로그인',
    aAuthSubmitting: '로그인 중...',
    aAuthNoPermission: '이 계정에는 백오피스 권한이 없습니다.',
    aAuthSessionExpired: '세션이 만료되었습니다. 다시 로그인해 주세요.',
    aAuthBackToSite: '회원 사이트로',
    aAuthEnterAdmin: '관리자 패널',
  },
  ja: {
    aAuthTitle: '管理者ログイン',
    aAuthSubtitle: '管理者専用のバックオフィス領域です。',
    aAuthIdentifier: '管理者アカウント',
    aAuthPassword: 'パスワード',
    aAuthSubmit: 'ログイン',
    aAuthSubmitting: 'ログイン中...',
    aAuthNoPermission: 'このアカウントにバックオフィス権限はありません。',
    aAuthSessionExpired: 'セッションの有効期限が切れました。再度ログインしてください。',
    aAuthBackToSite: '会員サイトへ戻る',
    aAuthEnterAdmin: '管理パネル',
  },
  zh: {
    aAuthTitle: '管理员登录',
    aAuthSubtitle: '后台管理专用入口，会员账号无法登录。',
    aAuthIdentifier: '管理员账号',
    aAuthPassword: '密码',
    aAuthSubmit: '登录后台',
    aAuthSubmitting: '登录中...',
    aAuthNoPermission: '该账号没有后台管理权限。',
    aAuthSessionExpired: '登录已过期，请重新登录。',
    aAuthBackToSite: '返回前台',
    aAuthEnterAdmin: '进入后台',
  },
};
